import { Component, OnInit } from '@angular/core';
import { BaseComponent, UtilsMisc, UtilsString } from '@pit/core';
import { IDtoDepot, IDtoDevice } from '@pit/frontend-model';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Observable } from 'rxjs';
import { PinItTrackFrontendServicesAccessor } from '../../module.core/accessor/implementations/pin.it.track.frontend.services.accessor';

@Component({
    selector: 'pin-it-track-frontend-device-dialog',
    templateUrl: './pin.it.track.frontend.device.dialog.component.html',
    styleUrls: ['./pin.it.track.frontend.device.dialog.component.scss']
})
export class PinItTrackFrontendDeviceDialogComponent extends BaseComponent {

    constructor(private servicesAccessor: PinItTrackFrontendServicesAccessor, private dialogRef: DynamicDialogRef, private dialogConfig: DynamicDialogConfig) {
        super(servicesAccessor.coreServicesAccessor.applicationService);

        this.device = this.dialogConfig.data.device;
    }

    public get canSave(): boolean {
        return ((UtilsMisc.isNullOrUndefined(this.device) === false) && (UtilsMisc.isNullOrUndefined(this.device.depot) === false) && (UtilsString.stringIsNullOrEmpty(this.device.account) === false));
    }

    public get isDepotInvalid(): boolean {
        return UtilsMisc.isNullOrUndefined(this.device?.depot);
    }

    public get isAccountInvalid(): boolean {
        return UtilsString.stringIsNullOrEmpty(this.device?.account);
    }

    public depots$: Observable<IDtoDepot[]> = this.servicesAccessor.entityStoreFacadesAccessor.depotStoreFacade.items$;

    public device: IDtoDevice = {};

    public async cancelAsync(): Promise<void> {
        this.dialogRef.close();
    }

    public async saveAsync(): Promise<void> {
        try {
            this.servicesAccessor.eventService.useMethod('busy.on');
            await this.servicesAccessor.entityStoreFacadesAccessor.deviceStoreFacade.saveItemAsync(this.device);
            //this.servicesAccessor.entityStoreFacadesAccessor.deviceStoreFacade.upsertItemToStore(this.device);
        } catch (error) {
        } finally {
            this.servicesAccessor.eventService.useMethod('busy.off');
        }
        this.dialogRef.close();
    }

    protected override async doOnAfterViewInitAsync(): Promise<void> {
        await super.doOnAfterViewInitAsync();

        try {
            this.servicesAccessor.eventService.useMethod('busy.on');
            await this.servicesAccessor.entityStoreFacadesAccessor.depotStoreFacade.loadDepotsForMandatorAsync(this.servicesAccessor.currentUser.mandator.id);
        } catch (error) {
            this.servicesAccessor.eventService.useMethod('error.log', error);
        } finally {
            this.servicesAccessor.eventService.useMethod('busy.off');
        }
    }

}
